let _ = t => t,
  _t;
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIImage from 'UIComponents/image/UIImage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { getUpgradePointImage } from 'ui-addon-upgrades/ums/getUpgradePointImage';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
import SkeletonLoadWrapper from '../components/common/loading/SkeletonLoadWrapper';
import HC0124MerchCard from '../components/merch-card/HC0124MerchCard';
import { APP } from '../constants/tracking/App';
import { SCREENS } from '../constants/tracking/Locations';
import FeatureContent from './FeatureContent';
import UpgradePageMerchCardPriceDisplay from './UpgradePageMerchCardPriceDisplay';
import { getHasSeatPurchaseMotions } from './utils/getHasSeatPurchaseMotions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "HC0124UpgradeConfigContent__FlexContainer",
  componentId: "sc-54iixn-0"
})(["z-index:1;padding-top:64px;", ";"], breakpoint.tablet(_t || (_t = _`
    padding-right: 48px;
    padding-left: 48px;
  `)));
const ImageWrapper = styled.div.withConfig({
  displayName: "HC0124UpgradeConfigContent__ImageWrapper",
  componentId: "sc-54iixn-1"
})(["text-align:center;margin:0 auto;"]);
const Container = styled.div.withConfig({
  displayName: "HC0124UpgradeConfigContent__Container",
  componentId: "sc-54iixn-2"
})(["max-width:315px;margin-top:16px;"]);
const getImage = upgradeConfig => {
  if (!upgradeConfig.visualKey) {
    return /*#__PURE__*/_jsx(ImageWrapper, {});
  }
  if (upgradeConfig.visualType === 'image') {
    return /*#__PURE__*/_jsx(ImageWrapper, {
      children: /*#__PURE__*/_jsx(UIImage, {
        style: {
          margin: '0 auto'
        },
        src: getUpgradePointImage(upgradeConfig.visualKey)
      })
    });
  }
  return /*#__PURE__*/_jsx(ImageWrapper, {
    children: /*#__PURE__*/_jsx(UIIllustration, {
      name: upgradeConfig.visualKey,
      height: 450
    })
  });
};
const HC0124UpgradeConfigContent = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick
}) => {
  const upgradeData = {
    app: APP,
    screen: SCREENS.UPGRADE_PAGE,
    uniqueId: upgradeConfig.upgradeKey,
    upgradeProduct: ApiNameToUpgradeProductMap[upgradePointApiName],
    apiName: upgradePointApiName,
    feature: upgradeConfig.feature
  };
  const HC0124MerchCardWrapper = () => {
    return /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(HC0124MerchCard, {
        upgradeData: upgradeData,
        purchaseMotions: purchaseMotions,
        upgradePointApiName: upgradePointApiName,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
      })
    });
  };
  const isLoading = !purchaseMotions;
  return /*#__PURE__*/_jsxs(FlexContainer, {
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-4",
      children: [/*#__PURE__*/_jsx(FeatureContent, {
        upgradeConfig: upgradeConfig,
        apiName: upgradePointApiName,
        hideHubProductHeader: getHasSeatPurchaseMotions(purchaseMotions)
      }), /*#__PURE__*/_jsx(UpgradePageMerchCardPriceDisplay, {
        apiName: upgradePointApiName
      }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: isLoading,
        heights: [40, 40],
        widths: [315, 315],
        Content: HC0124MerchCardWrapper
      })]
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 0,
      basis: "50%",
      className: "p-left-4",
      children: getImage(upgradeConfig)
    })]
  });
};
export default HC0124UpgradeConfigContent;